import { connect } from 'react-redux';
import PageLayout from '../components/PageLayout';

const mapStateToProps = ({ authentication }) => ({
  user: authentication
});

export default connect(mapStateToProps)(PageLayout);